import { render, staticRenderFns } from "./LotteriesMonth.vue?vue&type=template&id=5c201a2c&"
import script from "./LotteriesMonth.vue?vue&type=script&lang=js&"
export * from "./LotteriesMonth.vue?vue&type=script&lang=js&"
import style0 from "./LotteriesMonth.vue?vue&type=style&index=0&id=5c201a2c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports